import { types } from 'mobx-state-tree'

export const PriceRegionMeasurementUnitModel = types.model('PriceRegionMeasurementUnitModel', {
  id: types.number,
  priceRegionId: types.number,
})
